import BaseApi from './BaseApi';

export interface IFileManagement {
    uploadFile(projectId: number, file: FormData, jwt: string): Promise<object>;
    getList(jwt: string): Promise<object>;
}

export default class FileManagement extends BaseApi implements IFileManagement {
    constructor(baseURL: string) {
        super(baseURL);
    }

    uploadFile = (projectId: number, file: FormData, jwt: string) => {
        return this.postRequestFileUpload(`${this.baseUrl}v1.0/s3bucket/upload-file`, file, jwt);
    };

    getList = (jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/s3bucket`, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/FileManagement.ts